import LegalLayout from './LegalLayout'
import DocumentMeta from './DocumentMeta.jsx'

const LAST_UPDATED = '19 Φεβρουαρίου 2026'

function PrivacyPolicy() {
  return (
    <>
      <DocumentMeta
        title="Πολιτική Απορρήτου | Πανελλήνιες+"
        description="Πληροφορίες για την επεξεργασία προσωπικών δεδομένων στο Πανελλήνιες+ και για υπηρεσίες όπως Google AdSense, PostHog και Sentry."
        canonical="https://www.panellhniesplus.gr/privacy"
        robots="noindex, follow"
      />

      <LegalLayout title="Πολιτική Απορρήτου">
        <p>
          Τελευταία ενημέρωση: <strong>{LAST_UPDATED}</strong>
        </p>
        <p>
          Η παρούσα πολιτική εξηγεί πώς το Panellhnies<sup>+</sup> επεξεργάζεται δεδομένα προσωπικού
          χαρακτήρα όταν χρησιμοποιείτε τον ιστότοπο.
        </p>

        <h2>1. Ποιος είναι υπεύθυνος επεξεργασίας</h2>
        <p>
          Υπεύθυνος επεξεργασίας είναι ο διαχειριστής του Panellhnies<sup>+</sup>. Για θέματα ιδιωτικότητας
          μπορείτε να επικοινωνείτε μέσω της φόρμας feedback στη σελίδα <a href="/about">/about</a>.
        </p>

        <h2>2. Τι δεδομένα επεξεργαζόμαστε</h2>
        <ul>
          <li>Τεχνικά δεδομένα χρήσης (π.χ. σελίδα, συσκευή, browser, χρονική στιγμή).</li>
          <li>Δεδομένα που υποβάλλετε εθελοντικά μέσω της φόρμας feedback (μήνυμα, προαιρετικά email).</li>
          <li>Δεδομένα που προκύπτουν από cookies/παρόμοιες τεχνολογίες, σύμφωνα με τις επιλογές συγκατάθεσής σας.</li>
        </ul>

        <h2>3. Σκοποί και νομικές βάσεις</h2>
        <ul>
          <li>Λειτουργία και ασφάλεια υπηρεσίας: έννομο συμφέρον.</li>
          <li>Ανάλυση χρήσης (analytics): για στατιστική βελτίωση υπηρεσίας, ανάλογα με το ισχύον νομικό πλαίσιο.</li>
          <li>Προβολή διαφημίσεων (Google AdSense): συγκατάθεση μέσω banner cookies.</li>
          <li>Διαχείριση αιτημάτων υποστήριξης/feedback: συγκατάθεση ή έννομο συμφέρον, ανά περίπτωση.</li>
        </ul>

        <h2>4. Υπηρεσίες τρίτων</h2>
        <ul>
          <li>Google AdSense για προβολή διαφημίσεων.</li>
          <li>PostHog για analytics συμβάντων.</li>
          <li>Sentry για παρακολούθηση τεχνικών σφαλμάτων.</li>
          <li>Supabase για βάση δεδομένων και backend λειτουργίες.</li>
          <li>Vercel για φιλοξενία και βασικά στατιστικά επισκεψιμότητας.</li>
        </ul>
        <p>
          Οι παραπάνω πάροχοι ενδέχεται να επεξεργάζονται δεδομένα εκτός ΕΟΧ με κατάλληλους μηχανισμούς
          διαβίβασης (π.χ. συμβατικές ρήτρες).
        </p>

        <h2>5. Διαφημίσεις Google</h2>
        <p>
          Όταν δώσετε συγκατάθεση για διαφημίσεις, μπορεί να φορτώνεται το Google AdSense και να εμφανίζονται
          διαφημίσεις στο site. Οι ρυθμίσεις συγκατάθεσης εφαρμόζονται μέσω Google Consent Mode.
        </p>
        <p>
          Σε περιοχές όπου απαιτείται από την Google πολιτική συναίνεσης (π.χ. ΕΟΧ/ΗΒ/Ελβετία), ενδέχεται να
          απαιτείται πρόσθετη ρύθμιση πιστοποιημένου CMP στο λογαριασμό σας.
        </p>

        <h2>6. Χρόνος διατήρησης</h2>
        <p>
          Διατηρούμε τα δεδομένα μόνο για όσο είναι απαραίτητο για τους παραπάνω σκοπούς ή για συμμόρφωση με
          νομικές υποχρεώσεις.
        </p>

        <h2>7. Δικαιώματα υποκειμένων δεδομένων</h2>
        <p>
          Ανάλογα με τη νομοθεσία που σας καλύπτει, μπορείτε να ασκήσετε δικαιώματα πρόσβασης, διόρθωσης,
          διαγραφής, περιορισμού, εναντίωσης και φορητότητας. Μπορείτε επίσης να ανακαλέσετε τη συγκατάθεσή
          σας ανά πάσα στιγμή από τις ρυθμίσεις cookies.
        </p>

        <h2>8. Cookies και ανάκληση συγκατάθεσης</h2>
        <p>
          Για πλήρεις λεπτομέρειες δείτε την <a href="/cookies">Πολιτική Cookies</a>. Μπορείτε να αλλάξετε
          προτιμήσεις συγκατάθεσης μέσω των διαθέσιμων μηνυμάτων Google CMP όπου εφαρμόζονται.
        </p>

        <h2>9. Αλλαγές στην πολιτική</h2>
        <p>
          Ενδέχεται να ενημερώνουμε την παρούσα πολιτική. Η ημερομηνία τελευταίας ενημέρωσης αλλάζει στο πάνω
          μέρος της σελίδας.
        </p>
      </LegalLayout>
    </>
  )
}

export default PrivacyPolicy
